const UrlBase = process.env.VUE_APP_API_URL
export { UrlBase }
